<template>
  <div>
    <v-dialog v-model="estado" width="auto" persistent>
      <div class=" white d-flex justify-space-between">
        <v-card tile flat class="my-auto">
          <h1 class="white pa-1">
            Zonas de calor
          </h1>
        </v-card>
        <v-card tile flat class="my-auto">
          <v-btn
            @click="cambiarEstadoMapa()"
            outlined
            elevation="1"
            class="mx-1"
            >Cerrar</v-btn
          >
        </v-card>
      </div>
      <v-card id="mapContainer" tile> </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      estadoMapa: false,
      coordenadas: {
        lat: 0,
        lng: 0,
      },
      markers: [],
      map: "",
      accessToken:
        "pk.eyJ1Ijoiam9obmxpbmFyZXMiLCJhIjoiY2tjcWk2eDZrMTU2bjJyczVyMWF0ejg3NiJ9.848u9JaZDYfKTRPBzFvDwA",
    };
  },
  created() {
    this.geolocate();
  },
  props: ["estado"],
  methods: {
    geolocate() {
      this.$getLocation({})
        .then((coordinates) => {
          this.coordenadas = coordinates;
          var mymap = L.map("mapContainer").setView(this.coordenadas, 10);
          L.tileLayer(
            "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=" +
              this.accessToken,
            {
              attribution:
                'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
              maxZoom: 18,
              id: "mapbox/streets-v11",
              tileSize: 512,
              zoomOffset: -1,
              accessToken: this.accessToken,
            }
          ).addTo(mymap);

          var marker = L.marker(this.coordenadas)
            .addTo(mymap)
            .bindPopup("Mi Ubicación");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    cambiarEstadoMapa() {
      this.$emit("estadoMapa", this.estadoMapa);
    },
  },
};
</script>

<style scoped>
#mapContainer {
  height: 590px;
}
</style>
